const shareButtons = document.querySelectorAll(".js--share-button");

shareButtons.forEach((buttonEl) => {
    const shareContainer = buttonEl.querySelector(".share-container");
    buttonEl.addEventListener('click', () => {
        shareContainer.classList.toggle('active');
    });
})

